import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CmsService {

  // local URL
  private readonly baseURL = environment.apiUrl;

  constructor(private http: HttpClient) { }
 
  getContentBodyByLangAndId(controllerRoute: string, lang: string, id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/${controllerRoute}/get-content-body/${lang}/${id}`);
  }
}